/**
 * Created by tong on 2018/1/31.
 */
import React from 'react';

class InventoryQuery extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
}
export default InventoryQuery;


// WEBPACK FOOTER //
// ./src/routes/inventoryQuery/index.js